export default __webpack_public_path__ + "static/media/09_photo.a7ef5e84.jpg";